export enum BroadcasterKey {
  SignatureUpdated,
}
